import RetailInvoiceHistory from "./RetailInvoiceHistory";

function EcomInvoiceHistory() {
  return (
    <RetailInvoiceHistory
      endpoint="getEcomInvoice"
      pageTitle="Ecom Invoice History"
      badgeLabel="Ecom Sales Collection"
      description="Track invoices created from ecommerce checkout orders and monitor the money received from online customers."
      invoiceSubtitle="Ecom checkout receipt"
      deleteTitle="Delete ecom sale invoice?"
      deleteSuccessMessage="Ecom sale invoice deleted successfully."
      fetchErrorLabel="ecom invoice"
      previewErrorLabel="ecom invoice"
      collectionSubtitle="Ecom collection amount"
      exportTitle="Ecom CSV Export"
      filenamePrefix="ecom-invoice-report"
      invoiceType="ecom"
    />
  );
}

export default EcomInvoiceHistory;
